// @flow

import React from 'react';

import { withTranslation, Link } from '@i18n';
import GridCarousel from '@components/GridCarousel/index';
import ItemsCarousel from 'react-items-carousel';
import ProgressBar from '@components/ContributionCard/ProgressBar';

import { calculateGridUnitSize } from '@lib/helpers';
import {
  StyledCover,
  HeadingBlock,
  StyledHeading,
  StyledCardWrapper,
  Article,
  StyledVerifyIcon,
  PatientImage,
  PatientName,
  StyledPatientInfo,
  StyledPatientDetails,
  PatientCountry,
  StyledReviewTime,
  StyledCountryFlag,
  StyledLocationIcon,
  RatingStarIcon5,
  StyledRatingStars,
  PatientImageWrapper,
  StyledPlayIcon,
  StyledListItem,
  StyledWrapper
} from './styles';


const PatientTestimonial = ({
  t, isMobile, isTablet, onOpenModal, setVideoUrl
}: any) => {
  const PatientTestimonialList = [
    {
      blogLink: 'https://yapitahealth.com/en/blog/articles/success-story-nyok-mijok-garang-robotic-varicocelectomy-treated-at-yapita-health',
      patientPhoto: 'Nyok',
      backgroundColor: '#E7FFF8',
      flag: 'SS.svg',
      youTubeLink: 'https://www.youtube.com/embed/9a7jlwSGIuI?si=DWRpAElFcInq6yTW'
    },
    {
      blogLink: 'https://yapitahealth.com/en/blog/articles/success-story-graces-knee-replacement-surgery-at-yapita-health',
      patientPhoto: 'Grace',
      backgroundColor: '#E7FFFF',
      flag: 'KE.svg',
      youTubeLink: 'https://www.youtube.com/embed/y-tT8xU8V0E?si=LbRvJ2R_fqo-PEJw'
    },
    {
      blogLink: "https://yapitahealth.com/en/blog/articles/success-story-leelkunt's-full-body-check-up-at-yapita-health",
      patientPhoto: 'testimonial4',
      backgroundColor: '#F9FFE7',
      flag: 'MU.svg',
      youTubeLink: null
    },
    {
      blogLink: '',
      patientPhoto: 'Thabitha',
      backgroundColor: '#F9F8F8',
      flag: 'LS.svg',
      youTubeLink: 'https://www.youtube.com/embed/k62smaT-flk?si=xMXimTxF74iMfyOk'
    },
    {
      blogLink: 'https://yapitahealth.com/en/blog/articles/success-story-dharmen-angioplasty-treated-at-yapita-health',
      patientPhoto: 'DharmenSingh',
      backgroundColor: '#F0EDFF',
      flag: 'FJ.svg',
      youTubeLink: null
    },
    {
      blogLink: '',
      patientPhoto: 'Armia',
      backgroundColor: '#ffddc57d',
      flag: 'KM.svg',
      youTubeLink: 'https://www.youtube.com/embed/8DWMcZ07ksE?si=fxqIEhIc5RT3zsUu'
    },
    {
      blogLink: '',
      patientPhoto: 'George',
      backgroundColor: '#D2ECFF',
      flag: 'US.svg',
      youTubeLink: ''
    },
    {
      blogLink: '',
      patientPhoto: 'Joy',
      backgroundColor: '#F3F8F8',
      flag: 'KE.svg',
      youTubeLink: ''
    },
    {
      blogLink: '',
      patientPhoto: 'Tuula',
      backgroundColor: '#E7FFF8',
      flag: 'FI.svg',
      youTubeLink: ''
    }
  ];

  const [slide, setSlide] = React.useState(0);
  const color = '#5FA6BF';

  const handleClick = (link) => {
    if (link) {
      setVideoUrl(link);
      onOpenModal();
    }
  };
  return (
    <StyledCover>
      <HeadingBlock>
        <StyledHeading>
          {t('PatientTestimonial.Heading1')}
        </StyledHeading>
      </HeadingBlock>

      {isMobile
        ? (
          <>
            <ItemsCarousel
              requestToChangeActive={setSlide}
              activeItemIndex={slide}
              numberOfCards={1}
              gutter={20}
              alwaysShowChevrons
              showIndicators
            >

              {PatientTestimonialList.map((item, index) => (
                <>
                  <StyledCardWrapper
                    backgroundColor={item.backgroundColor}
                    index={index}
                  >
                    <StyledVerifyIcon alt="verified Icon" />
                    <StyledPatientInfo>
                      <PatientImageWrapper
                        onClick={() => handleClick(item?.youTubeLink)}
                        shadow={item?.youTubeLink}
                      >
                        <PatientImage
                          src={`../../../static/images/${item.patientPhoto}.webp`}
                          alt="Patient Photo"
                        />
                        {item?.youTubeLink ? <StyledPlayIcon alt="play Icon" /> : <></>}
                      </PatientImageWrapper>
                      <Link
                        href={item.blogLink}
                        blogLink={item.blogLink === ''}
                      >
                        <StyledPatientDetails>
                          <PatientName>
                            {t(`PatientTestimonial.PatientName${index + 1}`)}
                          </PatientName>
                          <PatientCountry>
                            <StyledLocationIcon alt="location Icon" />
                            {t(`PatientTestimonial.PatientCountry${index + 1}`)}
                            <StyledCountryFlag src={`../../../static/images/home/${item.flag}`} alt="Country Flag" />
                          </PatientCountry>
                          <StyledReviewTime>
                            {t(`PatientTestimonial.PatientReviewMonths${index + 1}`)}
                          </StyledReviewTime>
                        </StyledPatientDetails>
                      </Link>
                    </StyledPatientInfo>
                    {index === 3 ? <StyledRatingStars alt="rating Icon" /> : <RatingStarIcon5 alt="rating Icon" />}
                    <Link
                      href={item.blogLink}
                      blogLink={item.blogLink === ''}
                    >
                      <Article>
                        {t(`PatientTestimonial.PatientArticle${index + 1}`)}
                      </Article>
                    </Link>
                  </StyledCardWrapper>
                </>
              ))}
            </ItemsCarousel>
            <ProgressBar
              slide={slide}
              setSlide={setSlide}
              clickable
              color={color}
              homePage
              length={9}
              contributionCard
            />
          </>
        )
        : (
          <GridCarousel
            length={isTablet ? 8 : 9}
            onScreenCount={isTablet ? 2 : 3}
            pagination
            homePage
            contributionCard
          >
            <>
              {PatientTestimonialList.slice(0, isTablet ? 8 : 9).map((item, key) => (
                <StyledWrapper
                  size={isTablet
                    ? 1
          / calculateGridUnitSize(8, 2)
                    : 1 / 9}
                  key={key || item.patientPhoto}
                >
                  <StyledListItem>
                    <StyledCardWrapper backgroundColor={item.backgroundColor}>
                      <StyledVerifyIcon alt="verified Icon" />
                      <StyledPatientInfo>
                        <PatientImageWrapper
                          onClick={() => handleClick(item?.youTubeLink)}
                          shadow={item?.youTubeLink}
                        >
                          <PatientImage
                            src={`../../../static/images/${item.patientPhoto}.webp`}
                            alt="Patient Photo"
                          />
                          {item?.youTubeLink ? <StyledPlayIcon alt="play Icon" /> : <></>}
                        </PatientImageWrapper>
                        <Link href={item.blogLink}>
                          <StyledPatientDetails
                            blogLink={item.blogLink === ''}
                          >
                            <PatientName>
                              {t(`PatientTestimonial.PatientName${key + 1}`)}
                            </PatientName>
                            <PatientCountry>
                              <StyledLocationIcon alt="location Icon" />
                              {t(`PatientTestimonial.PatientCountry${key + 1}`)}
                              <StyledCountryFlag src={`../../../static/images/home/${item.flag}`} alt="Country Flag" />
                            </PatientCountry>
                            <StyledReviewTime>
                              {t(`PatientTestimonial.PatientReviewMonths${key + 1}`)}
                            </StyledReviewTime>
                          </StyledPatientDetails>
                        </Link>
                      </StyledPatientInfo>
                      {key === 3 ? <StyledRatingStars alt="rating Icon" /> : <RatingStarIcon5 alt="rating Icon" />}
                      <Link href={item.blogLink}>
                        <Article blogLink={item.blogLink === ''}>
                          {t(`PatientTestimonial.PatientArticle${key + 1}`)}
                        </Article>
                      </Link>
                    </StyledCardWrapper>
                  </StyledListItem>
                </StyledWrapper>
              ))}
            </>
          </GridCarousel>
        )}
    </StyledCover>
  );
};

export default withTranslation('Home')(PatientTestimonial);
